import React, { useState, useEffect } from "react";
import CustomMap from "../../component/CustomMap";
import { X, Facebook, Instagram, Youtube } from "lucide-react";
import VendorProfileCoupon from "./VendorProfileCoupon";
import { HTTP } from "../../api/http-common";
import { useParams } from 'react-router-dom';
import VendorGallery from "./VendorGallery";
import LocationCard from "../../component/LocationCard";
import '../../styling/vendorPage.css'
import { ElfsightWidget } from 'react-elfsight-widget';
import HeroBanner from "../../component/HeroBanner";

function VendorDetails() {
  const { id } = useParams();
  const [vendorAddresses, setVendorAddresses] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [vendorMediaList, setVendorMediaList] = useState([]);
  const [bannerImage, setBannerImage] = useState([]);

  useEffect(() => {
    loadvendor();
  }, []);

  
  useEffect(() => {
    // If banner image is set, dynamically inject the CSS rule
    if (bannerImage) {
      const styleSheet = document.styleSheets[0];
      const rule = `
        .vendor-hero-bg::before {
          background-image: url('${bannerImage}');
        }
      `;

      styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
  }, [bannerImage]);
  const loadvendor = async () => {
    HTTP.get("vendors/profile/info/" + id)
      .then((response) => {
        if (response.status === 200) {
          setVendorData(response.data.vendor_data);
          setVendorAddresses(response.data.vendor_addresses);
          setVendorMediaList(response.data.vendor_media);
          setBannerImage(response.data.vendor_data.banner_image);
          // Check if banner_image exists and set the state
          if (response.data.vendor_media && response.data.vendor_media.length > 0) {
            const banner = response.data.vendor_media.find(media => media.banner_image);

            if (banner) {
              // setBannerImage(banner.banner_image); // Set the banner image URL

              console.log("Banner Image:", banner.banner_image); // Log the URL to verify

            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // Handle unauthorized error
        }
      });

      
  }; return (
    <>
      {Array.isArray(vendorMediaList) && vendorMediaList.length > 0 && (
        <div className="vendor-slick-slider pb-2">
          <div className="full-width-container my-4 relative">
            <div className="w-full">
              <VendorGallery 
                key={vendorMediaList.length} 
                vendorMediaList={vendorMediaList} 
              />
            </div>
          </div>
        </div>
      )}
<div className="bg-[#f0f0f0] w-[99%] mx-auto rounded-[12px]">

          <div className=' h-[40dvh] w-full flex items-center justify-center'>
            <div className="">
              <h1 className='restaurant-title text-black text-center'> {vendorData.business_name || "BusinessName"}</h1>
              {/* Find the Perfect Plan for You! */}
              {/* <p className='vendor-hero-description text-center text-black'>   {vendorData.business_description || "Description"} </p> */}
              {/* Explore our tailored plans and pick the one that meets your needs. Flexibility and value, just for you. */}
            </div>

          </div>
          <div className="flex justify-end">
            <div className="social-media-section w-full">
                <div className="w-[130px]  pl-[9px]">
                  <span > Follow Us on :</span>
                </div>
                <div className=" flex items-center ">
                  <div className="mr-2.5">
                    {vendorData.x_url && vendorData.x_url !== '' ?
                      <a href={vendorData.x_url} target="_blank" className="custom-social-media-icons flex items-center justify-center rounded-full hover:bg-gray-200 transition ease-in-out duration-500">
                        {/* <X className="text-gray-500 hover:text-gray-800 transition ease-in-out duration-500" size={24} /> */}
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.683 1.6875H16.165L10.7439 7.88203L17.1213 16.3125H12.1291L8.21621 11.2008L3.74434 16.3125H1.25879L7.05605 9.68555L0.942383 1.6875H6.06113L9.59434 6.35977L13.683 1.6875ZM12.8111 14.8289H14.1857L5.3123 3.09375H3.83574L12.8111 14.8289Z" fill="black" />
                        </svg>

                      </a>
                      :
                      <a href="#" className="custom-social-media-icons flex items-center justify-center rounded-full hover:bg-gray-200 transition ease-in-out duration-500">
                        {/* <X className="text-gray-500 hover:text-gray-800 transition ease-in-out duration-500" size={24} /> */}
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.683 1.6875H16.165L10.7439 7.88203L17.1213 16.3125H12.1291L8.21621 11.2008L3.74434 16.3125H1.25879L7.05605 9.68555L0.942383 1.6875H6.06113L9.59434 6.35977L13.683 1.6875ZM12.8111 14.8289H14.1857L5.3123 3.09375H3.83574L12.8111 14.8289Z" fill="black" />
                        </svg>

                      </a>
                    }
                  </div>

                  <div className="mr-2.5">
                    {vendorData.facebook_url && vendorData.facebook_url !== '' ?
                      <a href={vendorData.facebook_url} target="_blank" className="custom-social-media-icons flex items-center justify-center rounded-full hover:bg-gray-200 transition ease-in-out duration-500">
                        <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.35254 10.375H6.71582V18.25H3.2002V10.375H0.317383V7.14062H3.2002V4.64453C3.2002 1.83203 4.8877 0.25 7.4541 0.25C8.68457 0.25 9.98535 0.496094 9.98535 0.496094V3.27344H8.54395C7.1377 3.27344 6.71582 4.11719 6.71582 5.03125V7.14062H9.84473L9.35254 10.375Z" fill="#4797FF" />
                        </svg>
                      </a>
                      :
                      <a href="#" className="custom-social-media-icons flex items-center justify-center rounded-full hover:bg-gray-200 transition ease-in-out duration-500">
                        <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.35254 10.375H6.71582V18.25H3.2002V10.375H0.317383V7.14062H3.2002V4.64453C3.2002 1.83203 4.8877 0.25 7.4541 0.25C8.68457 0.25 9.98535 0.496094 9.98535 0.496094V3.27344H8.54395C7.1377 3.27344 6.71582 4.11719 6.71582 5.03125V7.14062H9.84473L9.35254 10.375Z" fill="#4797FF" />
                        </svg>
                      </a>
                    }
                  </div>

                  <div className="mr-2.5">
                    {vendorData.youtube_url && vendorData.youtube_url !== '' ?
                      <a href={vendorData.youtube_url} target="_blank" className="custom-social-media-icons  flex items-center justify-center rounded-full hover:bg-gray-200 transition ease-in-out duration-500">

                        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19.3408 2.64453C19.7627 4.12109 19.7627 7.28516 19.7627 7.28516C19.7627 7.28516 19.7627 10.4141 19.3408 11.9258C19.1299 12.7695 18.4619 13.4023 17.6533 13.6133C16.1416 14 10.165 14 10.165 14C10.165 14 4.15332 14 2.6416 13.6133C1.83301 13.4023 1.16504 12.7695 0.954102 11.9258C0.532227 10.4141 0.532227 7.28516 0.532227 7.28516C0.532227 7.28516 0.532227 4.12109 0.954102 2.64453C1.16504 1.80078 1.83301 1.13281 2.6416 0.921875C4.15332 0.5 10.165 0.5 10.165 0.5C10.165 0.5 16.1416 0.5 17.6533 0.921875C18.4619 1.13281 19.1299 1.80078 19.3408 2.64453ZM8.19629 10.1328L13.1885 7.28516L8.19629 4.4375V10.1328Z" fill="#ED1C24" />
                        </svg>

                      </a>
                      :
                      <a href="#" className="custom-social-media-icons flex items-center justify-center rounded-full hover:bg-gray-200 transition ease-in-out duration-500">
                        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19.3408 2.64453C19.7627 4.12109 19.7627 7.28516 19.7627 7.28516C19.7627 7.28516 19.7627 10.4141 19.3408 11.9258C19.1299 12.7695 18.4619 13.4023 17.6533 13.6133C16.1416 14 10.165 14 10.165 14C10.165 14 4.15332 14 2.6416 13.6133C1.83301 13.4023 1.16504 12.7695 0.954102 11.9258C0.532227 10.4141 0.532227 7.28516 0.532227 7.28516C0.532227 7.28516 0.532227 4.12109 0.954102 2.64453C1.16504 1.80078 1.83301 1.13281 2.6416 0.921875C4.15332 0.5 10.165 0.5 10.165 0.5C10.165 0.5 16.1416 0.5 17.6533 0.921875C18.4619 1.13281 19.1299 1.80078 19.3408 2.64453ZM8.19629 10.1328L13.1885 7.28516L8.19629 4.4375V10.1328Z" fill="#ED1C24" />
                        </svg>

                      </a>
                    }
                  </div>
                </div>
              </div>
          </div>
</div>
      


      <div className="container">
        <div className="">
          {Array.isArray(vendorAddresses) && vendorAddresses.length > 0 ? (
            <>
              <div className="py-6">
                <div className="container max-w-screen-xl mx-auto px-4">
                  <div className="text-center">
                    <h6 className="section-title py-2 ">Where to Find Us</h6>
                    {/* <p className="section-desciption mx-4">
                      Making it easy for you to reach us!
                    </p> */}
                  </div>
                </div>
              </div>
              {vendorAddresses.map((location, index) => (
                <>
                  <LocationCard location={location} />
                </>
              ))}
              
            </>
          ) : (
            null
          )}
          <div className="py-6">
            <div className=" max-w-screen-xl mx-auto px-4">
              <div className="text-center">
                <h6 className="section-title ">
                  Grab Your Deals Now
                </h6>
                {/* <p className="section-desciption mx-4">
                  Grab Your Coupons Now
                </p> */}
              </div>
            </div>
          </div>
          <VendorProfileCoupon backgroundColor={false} />

        </div>
      </div>

      {/* <div className="py-3">
        <div className=" max-w-screen-xl mx-auto px-4">
          <div className="text-center">
            <h6 className="section-title">
              Yelp Reviews
            </h6>
          </div>
        </div>
      </div>
      <div className="container bg-white rounded-2xl mb-10">
        <div className="custom-review-ui custom-theme-scroll mt-3 ">
          <ElfsightWidget widgetId={`${'1bce7df9-8093-49e9-a629-8b5427281e0f'}`} lazy modern />
        </div>
      </div> */}

      {/* mb-20 md:mb-10 lg::mb-52 */}
    </>
  );
}

export default VendorDetails;